module.exports = __webpack_public_path__ + "static/media/ceilings-001.f379dcbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/ceilings-001.jpg
// module id = 89
// module chunks = 0